import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useContext, useEffect, useMemo, useState } from "react";
import { ResourceLinkingTabs } from "../constants";
import { PatientsContext } from "../../Patients/PatientsContext";
import useGetPatientAttachments from "../../SummarySection/services/useGetPatientAttachments";
import { get, isEqual } from "lodash";
import { t } from "i18next";
import { useApplyReportTag } from "../../Chat/Message/RadiologyReportCard/useApplyReportTag";
export function useLinkPatientRecordsModal(_ref) {
  var _encounters$data$page, _encounters$data, _reports$data$pages$f, _reports$data;
  var onClose = _ref.onClose,
    onLink = _ref.onLink,
    linkedRes = _ref.linkedRes;
  var _useState = useState(ResourceLinkingTabs.REPORTS),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useState2 = useState(linkedRes),
    linkedResources = _useState2[0],
    setLinkedResources = _useState2[1];
  useEffect(function () {
    setLinkedResources(linkedRes);
  }, [linkedRes]);
  var _ref2 = useContext(PatientsContext),
    currentPatient = _ref2.currentPatient,
    selectedWorkspace = _ref2.selectedWorkspace,
    customFields = _ref2.customFields,
    patientTags = _ref2.patientTags;
  var _useApplyReportTag = useApplyReportTag({
      patientId: currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid
    }),
    onApplyTag = _useApplyReportTag.onApplyTag,
    applyingTagId = _useApplyReportTag.applyingTagId,
    buildCardData = _useApplyReportTag.buildCardData;
  var workspaceId = selectedWorkspace && selectedWorkspace.value ? Number(selectedWorkspace.value) : null;
  var patientId = currentPatient && currentPatient.patient_uid ? String(currentPatient.patient_uid) : null;
  var _useGetPatientAttachm = useGetPatientAttachments(workspaceId, patientId),
    reports = _useGetPatientAttachm.reports,
    appointments = _useGetPatientAttachm.appointments,
    encounters = _useGetPatientAttachm.encounters;
  var allEncounters = (_encounters$data$page = (_encounters$data = encounters.data) === null || _encounters$data === void 0 ? void 0 : _encounters$data.pages.flatMap(function (p) {
    return p.encounters;
  })) !== null && _encounters$data$page !== void 0 ? _encounters$data$page : [];
  var isLinkDisabled = useMemo(function () {
    return isEqual(linkedRes, linkedResources);
  }, [linkedResources, linkedRes]);
  var tabs = [{
    id: ResourceLinkingTabs.REPORTS,
    label: t("reports") || "Reports"
  }, {
    id: ResourceLinkingTabs.APPOINTMENTS,
    label: t("appointments") || "Appointments"
  }, {
    id: ResourceLinkingTabs.ENCOUNTERS,
    label: t("encounters") || "Encounters"
  }];
  var handleToggleSelection = function handleToggleSelection(id, resourceType) {
    setLinkedResources(function (prev) {
      return _objectSpread(_objectSpread({}, linkedResources), {}, _defineProperty({}, resourceType, prev[resourceType].includes(id) ? prev[resourceType].filter(function (x) {
        return x !== id;
      }) : [].concat(_toConsumableArray(prev[resourceType]), [id])));
    });
  };
  var handleCancel = function handleCancel() {
    setLinkedResources(linkedRes);
    onClose();
  };
  var handleLink = function handleLink() {
    return onLink(linkedResources);
  };
  return {
    activeTab: activeTab,
    onTabChange: setActiveTab,
    linkedResources: linkedResources,
    onToggleSelection: handleToggleSelection,
    selectedCount: linkedResources.appointments.length + linkedResources.encounters.length + linkedResources.reports.length,
    tabs: tabs,
    handleCancel: handleCancel,
    handleLink: handleLink,
    isLinkDisabled: isLinkDisabled,
    reports: (_reports$data$pages$f = (_reports$data = reports.data) === null || _reports$data === void 0 ? void 0 : _reports$data.pages.flatMap(function (p) {
      return p.results;
    })) !== null && _reports$data$pages$f !== void 0 ? _reports$data$pages$f : [],
    onLoadMoreReports: function onLoadMoreReports() {
      return reports.fetchNextPage();
    },
    hasNextReportsPage: !!reports.hasNextPage,
    isFetchingNextReportsPage: reports.isFetchingNextPage,
    customFields: customFields || [],
    patientTags: patientTags || [],
    onApplyTag: onApplyTag,
    applyingTagId: applyingTagId,
    buildCardData: buildCardData,
    appointments: [].concat(_toConsumableArray(get(appointments, ["data", "today"], [])), _toConsumableArray(get(appointments, ["data", "future"], [])), _toConsumableArray(get(appointments, ["data", "past"], []))),
    encounters: allEncounters,
    noOfEncounters: get(encounters, ["data", "pages", "0", "total_count"], allEncounters.length),
    onLoadMoreEncounters: function onLoadMoreEncounters() {
      return encounters.fetchNextPage();
    },
    hasNextEncountersPage: !!encounters.hasNextPage,
    isFetchingNextEncountersPage: encounters.isFetchingNextPage
  };
}